import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 3;
  background: var(--Shades-900, #1c1c1c);
  padding: 20px 24px 40px 24px !important;
  margin: 0px !important;
  padding: 40px 20px !important;

  ${media.md`
    padding: 60px 44px !important;
    gap: 40px;
  `}

  ${media.lg`
    padding: 80px !important;
    gap: 60px;
  `}
`;

export const StyledContentBlock = styled.div`
  padding: 0px !important;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const Contentwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
`;

export const Title = styled.h2`
  color: var(--Primary-White-Paper, #fff);
  text-align: center;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 85%; /* 81px */
  letter-spacing: -0.8px;
  text-transform: uppercase;
  display: flex;
  margin: 0px;
  ${media.md`
    font-size: 60px;
    line-height: 90%;
    letter-spacing: -1.2px;
  `}
  ${media.lg`
    font-size: 80px;
    letter-spacing: -1.8px;
  `}
  ${media.xl`
    font-size: 90px;
  `}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  ${media.md`
    align-items: flex-start;
  `}
`;

export const Topwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

export const Stepwrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
  flex-direction: column;
  ${media.lg`
    flex-direction: row;
  `}
`;

// New wrapper for step content area
export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

// New wrapper for image container
export const StepImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${media.md`
    width: 50%;
  `}
  ${media.lg`
    width: 40%;
  `}
`;

export const Step1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  border-radius: 10px;
  background: var(--Green-500, #2aa5a5);
  overflow: hidden;
  align-self: stretch;
  min-height: 380px;

  ${media.md`
    flex-direction: row-reverse;
    height: 280px;
  `}

  ${media.lg`
    height: unset;
    flex-direction: row;
    flex-direction: column;
  `}
`;

export const Step2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  border-radius: 10px;
  background: var(--Purple-500, #a395cc);
  overflow: hidden;
  align-self: stretch;
  min-height: 380px;

  ${media.md`
    flex-direction: row-reverse;
    height: 280px;
  `}

  ${media.lg`
    height: unset;
    flex-direction: row;
    flex-direction: column;
  `}
`;

export const Step3 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  border-radius: 10px;
  background: var(--Primary-Satoshi-Orange, #f7931a);
  overflow: hidden;
  align-self: stretch;
  min-height: 380px;

  ${media.md`
    flex-direction: row-reverse;
    height: 280px;
  `}

  ${media.lg`
    height: unset;
    flex-direction: row;
    flex-direction: column;
  `}
`;

export const Stepimage = styled.img`
  display: none;
  ${media.lg`
    display: flex;
    width: 100%;
    height: 100%;
    object-fit: cover;
  `}
`;

export const Stepimagemobile = styled.img`
  display: flex;
  width: 100%;
  height: 218px;
  object-fit: contain;
  border-radius: 10px 10px 0 0;

  ${media.md`
    height: 100%;
    border-radius: 0;
    object-fit: cover;
  `}

  ${media.lg`
    display: none;
  `}
`;

export const Steplower = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  text-align: start;
  flex: 1;
  justify-content: center;

  ${media.md`
    padding: 24px;
    justify-content: flex-start;
  `}

  ${media.lg`
    padding: 32px;
    justify-content: center;  
  `}
`;

export const StepContentwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const StepTitle = styled.h2`
  color: var(--Primary-White-Paper, #fff);
  font-family: 'Elza Condensed', sans-serif;
  font-size: 23px;
  font-style: normal;
  font-weight: 900;
  line-height: 85%;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 0px;
  text-align: start;

  ${media.md`
    font-size: 40px;
  `}
`;

export const StepSubtitle = styled.p`
  color: var(--Primary-White-Paper, #fff);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 123%;
  margin: 0px;

  ${media.md`
    font-size: 22px;
  `}
`;

export const Bluewrapper = styled.div`
  display: none;
  ${media.lg`
    height: 150px;
    border-radius: 10px;
    background: var(--Primary-Skychain, #4169e1);
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
  `}
`;

export const BlueTitle = styled.h2`
  color: var(--Primary-White-Paper, #fff);
  font-family: 'Elza Condensed', sans-serif;
  font-size: 60px;
  font-style: normal;
  font-weight: 900;
  line-height: 90%;
  letter-spacing: -1.2px;
  text-transform: uppercase;
  margin: 0px;
  flex: 1;
  ${media.lg`
    font-size: 50px;
  `}
  ${media.xl`
    font-size: 60px;
  `}
`;

export const Iconwrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

export const Step1imagewrapper = styled.div`
  width: 100%;
  height: 218px;
  background: var(--Green-100, #b9e5de);
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.md`
    height: 100%;
    width: 50%;
  `}
  ${media.lg`
    height: 100%;
    width: 100%;
  `}
`;

export const Step2imagewrapper = styled.div`
  width: 100%;
  height: 218px;
  background: var(--Purple-100, #e0d0f5);
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.md`
    height: 100%;
    width: 50%;
  `}
  ${media.lg`
    height: 100%;
    width: 100%;
  `}
`;

export const Step3imagewrapper = styled.div`
  width: 100%;
  height: 218px;
  background: var(--Orange-100, #ffe2c8);
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.md`
    height: 100%;
    width: 50%;
  `}
  ${media.lg`
    height: 100%;
    width: 100%;
  `}
`;

export const Appstore = styled.a`
  display: flex;
  padding: 15px 25.864px 15px 25px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: var(--Primary-White-Paper, #fff);
`;

export const Playstore = styled.a`
  display: flex;
  padding: 15px 25.864px 15px 25px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: var(--Primary-White-Paper, #fff);
`;

export const Appstoreicon = styled.img`
  width: 135.136px;
  height: 36px;
  flex-shrink: 0;
  aspect-ratio: 135.14/36;
  ${media.lg`
    width: 100.136px;
    height: 36px;
  `}
  ${media.xl`
    width: 135.136px;
    height: 36px;
  `}
`;

export const Playstoreicon = styled.img`
  width: 135.136px;
  height: 36px;
  flex-shrink: 0;
  aspect-ratio: 135.14/36;
  ${media.lg`
    width: 100.136px;
    height: 36px;
  `}
  ${media.xl`
    width: 135.136px;
    height: 36px;
  `}
`;

export const QRicon = styled.img`
  display: flex;
  width: 66px;
  height: 66px;
  justify-content: center;
  align-items: center;
  ${media.lg`
   width: 60px;
   height: 60px;
  `}
  ${media.xl`
   width: 66px;
   height: 66px;
  `}
`;

export const Button = styled.button`
  display: flex;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 9px;
  width: 142px;
  border: none;
  border-radius: 116.162px;
  background: var(--Primary-Satoshi-Orange, #f7931a);
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  ${media.md`
   height: 48px;
   gap: 8px;
   width:205px;
  `}
  ${media.lg`
     display:none;
  `}
`;

export const ButtonText = styled.p`
  color: var(--Grey-Scale-900, #1c1c1c);
  text-align: center;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0px;
  ${media.md`
   font-size: 18px;
   line-height:130%;
  `}
`;

export const Blackcircle = styled.img`
  width: 20px;
  height: 20px;
  ${media.md`
   width: 28px;
   height: 28px;
  `}
`;
